import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {TenantsService} from './services/tenants.service';
import {TenantsComponent} from './tenants/tenants.component';
import {TenantComponent} from './tenant/tenant.component';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {path: 'tenants', component: TenantsComponent},
    {path: 'tenants/tenant/:id', component: TenantComponent}
];

@NgModule({
    declarations: [TenantsComponent, TenantComponent],
    imports: [CommonModule, RouterModule.forChild(routes), TranslateModule.forRoot()],
    exports: [RouterModule],
    providers: [TenantsService]
})
export class ConfigModule {
}



// WEBPACK FOOTER //
// ./src/app/config/config.module.ts